import clone from 'lodash/clone'
import { useIntl } from 'react-intl'
import { setLocale } from 'yup'
import yupLocale from 'yup/es/locale'
import { useConstructor } from '../../hooks/useConstructor'
import { addValidators } from './yup-validators'

let setLocaleCalled = false

/**
 * Transform yup locale messages into formatted messages
 * Keep logic in sync with {@link /packages/intl/src/yup.js}
 */
const yupIntlLocale = (formatMessage) => {
	if (typeof yupLocale.mixed.required === 'function') {
		// We can assume that setLocale has been called before when yupLocale.mix.required is a function
		return {}
	}
	const locale = {}
	Object.keys(yupLocale).forEach((area) => {
		locale[area] = {}
		Object.keys(yupLocale[area]).forEach((validation) => {
			if (typeof yupLocale[area][validation] === 'function') {
				const message = yupLocale[area][validation]
				locale[area][validation] = (values) => {
					console.warn(`Yup ${area} ${validation} is not localized because it is a function. Rewrite it.`)
					return formatMessage(
						{
							id: ['yup', area, validation].join('_').toLocaleLowerCase(),
							defaultMessage: message(values),
						},
						values
					)
				}
			} else if (typeof yupLocale[area][validation] === 'string') {
				const message = clone(yupLocale[area][validation])
				locale[area][validation] = (values) => {
					return formatMessage(
						{
							id: ['yup', area, validation].join('_').toLocaleLowerCase(),
							defaultMessage: message.replace(/\$\{/g, '{'), // remove $ before { to comply with Format.JS
						},
						values
					)
				}
			}
		})
	})

	return locale
}

const YupConfig = () => {
	const { formatMessage } = useIntl()

	useConstructor(() => {
		if (!setLocaleCalled) {
			setLocale(yupIntlLocale(formatMessage)) // run always to give children access to the new translated messages
			setLocaleCalled = true
		}
		addValidators(formatMessage) // run always to give children access to the new validators
	})

	return null
}

export default YupConfig
